import { type FC, type ReactElement } from "react";

import { Badge } from "@mantine/core";

import { TopPerformerLensStatus } from "../../models";

import { awarded, chip, didNotQualify, inWindow, underReview, unknown } from "./TopPerformerStatusChip.module.css";
import {
    StatusAwarded,
    StatusDidNotQualify,
    StatusInWindow,
    StatusUnderReview,
    StatusUnknown,
} from "./messages.generated";

interface Chip {
    className: string;
    Label: () => ReactElement;
}

const CHIP_BY_STATUS = new Map<string, Chip>(
    Object.entries({
        [TopPerformerLensStatus.Awarded]: { className: awarded, Label: StatusAwarded },
        [TopPerformerLensStatus.UnderReview]: { className: underReview, Label: StatusUnderReview },
        [TopPerformerLensStatus.InWindow]: { className: inWindow, Label: StatusInWindow },
        [TopPerformerLensStatus.DidNotQualify]: { className: didNotQualify, Label: StatusDidNotQualify },
    } satisfies Record<Exclude<TopPerformerLensStatus, TopPerformerLensStatus.Unknown>, Chip>),
);

const UNKNOWN_CHIP: Chip = { className: unknown, Label: StatusUnknown };

export const TopPerformerStatusChip: FC<{ status: TopPerformerLensStatus }> = ({ status }) => {
    // A server enum value newer than this bundle renders neutral rather than crashing the row.
    const { className, Label } = CHIP_BY_STATUS.get(status) ?? UNKNOWN_CHIP;
    return (
        <Badge radius="xl" variant="light" tt="none" className={`${chip} ${className}`}>
            <Label />
        </Badge>
    );
};
